import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Globals} from '../../global/globals';
import {Observable} from 'rxjs';
import {SharedService} from '../common/shared.service';
import {VerbalActionEntryPageDto} from "../../dtos/verbal-action/entry/verbal-action-entry-page-dto";
import {VerbalActionEntryDto} from "../../dtos/verbal-action/entry/verbal-action-entry-dto";
import {VerbalActionEntryCreationDto} from "../../dtos/verbal-action/entry/verbal-action-entry-creation-dto";

@Injectable({
  providedIn: 'root'
})
export class VerbalActionEntryService {

  private baseUri: string = this.globals.backendUri + '/va/entries';

  constructor(private httpClient: HttpClient, private globals: Globals, private sharedService: SharedService) {
  }

  searchEntries(params: HttpParams): Observable<VerbalActionEntryPageDto> {
    return this.httpClient.get<VerbalActionEntryPageDto>(this.baseUri, {params});
  }

  getEntry(id: number): Observable<VerbalActionEntryDto> {
    return this.httpClient.get<VerbalActionEntryDto>(this.baseUri + '/' + id);
  }

  createEntry(entry: VerbalActionEntryCreationDto): Observable<VerbalActionEntryDto> {
    return this.httpClient.post<VerbalActionEntryDto>(this.baseUri, entry);
  }

  updateEntry(id: number, entry: VerbalActionEntryCreationDto): Observable<VerbalActionEntryDto> {
    return this.httpClient.put<VerbalActionEntryDto>(this.baseUri + '/' + id, entry);
  }

  deleteEntry(id: number): Observable<void> {
    return this.httpClient.delete<void>(this.baseUri + '/' + id);
  }

  getEntryAsArray(entry: VerbalActionEntryDto) {
    const tmpEntries = this.sharedService.filterNullOrEmpty(this.sharedService.extractReferences(entry));
    const entries = [];
    for (const tmpEntry of tmpEntries) {
      if (tmpEntry[0] === 'id' || tmpEntry[0] === 'name') continue;
      if (tmpEntry[0] === 'receptive') {
        tmpEntry[0] = 'Rezeptiv';
      } else if (tmpEntry[0] === 'productive') {
        tmpEntry[0] = 'Produktiv';
      } else if (tmpEntry[0] === 'examples') {
        tmpEntry[0] = 'Beispiele';
      } else if (tmpEntry[0] === 'category') {
        tmpEntry[0] = 'Thema';
        tmpEntry[1] = this.sharedService.getCategoryTree(tmpEntry[1]);
      }
      entries.push(tmpEntry);
    }
    return entries;
  }
}
